import { Box, CircularProgress, Stack } from "@mui/material";
import { ReactNode } from "react";

import AppButton from "../Button/AppButton";
import AppIconButton from "../Button/AppIconButton";
import AppIcon from "../Icons/AppIcon";

interface Props {
  isLoading?: boolean;
  tabs?: ReactNode;
  actions?: ReactNode;
  onRefetch?: () => void;
  onCreateEntry?: () => void;
}

/** External/extra calendar toolbar additionally to the main calendar toolbar. */
export function CalendarExternalToolbar({
  isLoading,
  tabs,
  actions,
  onRefetch,
  onCreateEntry,
}: Props) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gap: 1,
        gridTemplateColumns: { xxs: "1fr", lg: "1fr 1fr" },
        borderBottom: (th) => `1px solid ${th.palette.divider}`,
      }}
    >
      <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
        {/* Tabs */}
        {tabs && (
          <Box sx={{ display: "flex", alignItems: "center", minWidth: 0, overflow: "hidden" }}>
            {tabs}
          </Box>
        )}

        {isLoading && <CircularProgress size={18} />}
      </Stack>

      {/* Actions */}
      <Box>
        <Stack
          direction='row'
          gap={0.25}
          sx={{ height: "100%", justifyContent: "flex-end", alignItems: "center" }}
        >
          {onCreateEntry && (
            <AppButton
              sx={{ mr: 1 }}
              variant='contained'
              color='primary'
              size='medium'
              startIcon={<AppIcon of='add' />}
              onClick={onCreateEntry}
            >
              New entry
            </AppButton>
          )}

          {actions}

          {onRefetch && (
            <AppIconButton
              tooltipProps={{ title: "Refresh", enterDelay: 300, enterNextDelay: 300 }}
              onClick={onRefetch}
            >
              <AppIcon of='refresh' />
            </AppIconButton>
          )}
        </Stack>
      </Box>
    </Box>
  );
}
